/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withContext } from '@ba-ui-toolkit/context';
import { lodash } from '@ba-ui-toolkit/utils';
import Flyout from './Flyout.js';

const { omit } = lodash;

@withContext('theme')
export default class ContextFlyout extends Component {
	static propTypes = {
		theme: PropTypes.string,
		...Flyout.propTypes,
	};

	static defaultProps = {
		className: '',
	};

	render() {
		const { theme, children } = this.props;
		const otherProps = omit(this.props, 'theme', 'children', 'className');

		return (
			<Flyout
				{...otherProps}
				className={`${theme} ${this.props.className}`}
				ref={node => {
					this._flyout = node;
				}}
			>
				{children}
			</Flyout>
		);
	}
}
